<template lang="pug">
    game-master-directory

</template>

<script>
export default {
    name: 'game-master-directory-page',

    data() { return {
    }},
}
</script>
